import { render, staticRenderFns } from "./CaptureNationalBack.vue?vue&type=template&id=a40d9ee0&"
import script from "./CaptureNationalBack.vue?vue&type=script&lang=ts&"
export * from "./CaptureNationalBack.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports